import { Call02Icon, Clock01Icon, Location03Icon, Mail01Icon, MessengerIcon } from '@hugeicons/core-free-icons';
import { HugeiconsIcon } from '@hugeicons/react';
import { Link } from 'react-router-dom';
import { address, companyName, domain, email, phone, workingTime } from 'src/constants';
import { getTel } from 'src/helpers';

const Footer = () => {
	return (
		<footer className='bg-[#27353e] text-white'>
			<div className='container py-10'>
				<div className='grid grid-cols-1 md:grid-cols-4 gap-10 md:gap-12'>
					<div>
						<Link to='/' className='inline-block mb-4'>
							<img src='/logo2.png' alt='logo' className='w-[180px]' />
						</Link>
						<div className='flex items-start gap-2 text-[13px] opacity-90'>
							<HugeiconsIcon icon={Location03Icon} size={20} className='mt-0.5 flex-none' />
							<span>Địa chỉ: {address}</span>
						</div>
						<div className='flex items-center gap-2 mt-3 text-[13px] opacity-90'>
							<HugeiconsIcon icon={Clock01Icon} size={18} />
							<span>Giờ làm việc: {workingTime}</span>
						</div>
						<div className='mt-3 text-[13px] opacity-90'>{companyName}</div>
					</div>

					<div>
						<div className='font-semibold text-base mb-4'>Hỗ trợ khách hàng</div>
						<ul className='flex flex-col gap-3 text-[13px]'>
							<li>
								<Link to='/cam-ket-chat-luong' className='hover:text-[#2074be]'>
									Cam kết chất lượng
								</Link>
							</li>
							<li>
								<Link to='/lien-he' className='hover:text-[#2074be]'>
									Liên hệ
								</Link>
							</li>
							<li>
								<Link to='/gioi-thieu' className='hover:text-[#2074be]'>
									Giới thiệu
								</Link>
							</li>
							<li>
								<Link to='/tin-tuc' className='hover:text-[#2074be]'>
									Tin tức
								</Link>
							</li>
						</ul>
					</div>

					<div>
						<div className='font-semibold text-base mb-4'>Điều khoản & chính sách</div>
						<ul className='flex flex-col gap-3 text-[13px]'>
							<li>
								<Link to='/huong-dan-dat-hang' className='hover:text-[#2074be]'>
									Hướng dẫn đặt hàng
								</Link>
							</li>
							<li>
								<Link to='/dieu-khoan-su-dung' className='hover:text-[#2074be]'>
									Điều khoản sử dụng
								</Link>
							</li>
							<li>
								<Link to='/chinh-sach-doi-tra-hang' className='hover:text-[#2074be]'>
									Chính sách đổi trả hàng
								</Link>
							</li>
							<li>
								<Link to='/chinh-sach-khieu-nai' className='hover:text-[#2074be]'>
									Chính sách khiếu nại
								</Link>
							</li>
							<li>
								<Link to='/chinh-sach-bao-hanh' className='hover:text-[#2074be]'>
									Chính sách bảo hành
								</Link>
							</li>
						</ul>
					</div>

					<div>
						<div className='font-semibold text-base mb-4'>Hotline</div>
						<div className='flex items-center gap-4 mb-4'>
							<HugeiconsIcon icon={Call02Icon} size={28} color='#2074be' />
							<a href={`tel:${getTel()}`} className='font-semibold text-2xl text-[#2074be]'>
								{phone}
							</a>
						</div>
						<div className='mb-4 text-[13px]'>{workingTime}</div>
						<div className='flex gap-2'>
							<a href={`mailto:${email}`} className='p-2 rounded bg-[#424242] hover:-translate-y-1 inline-flex transition-transform' title='Email'>
								<HugeiconsIcon icon={Mail01Icon} size={18} />
							</a>
							<a
								href='https://m.me/pham.uc.509274'
								target='_blank'
								rel='noopener noreferrer'
								className='p-2 rounded bg-[#1d7dfb] hover:-translate-y-1 inline-flex transition-transform'
								title='Messenger'
							>
								<HugeiconsIcon icon={MessengerIcon} size={18} />
							</a>
							<a href={`tel:${getTel()}`} className='p-2 rounded bg-[#ef4444] hover:-translate-y-1 inline-flex transition-transform' title='Gọi ngay'>
								<HugeiconsIcon icon={Call02Icon} size={18} />
							</a>
						</div>
						<div className='mt-5 text-xs opacity-70'>MST: 0201234567 — Sở KH&ĐT TP. Hải Phòng</div>
					</div>
				</div>
			</div>

			<div className='bg-[#1c272e]'>
				<div className='container py-4 flex flex-wrap justify-between items-center gap-2 text-xs opacity-75'>
					<div>
						© {new Date().getFullYear()} {companyName}. All rights reserved.
					</div>
					<div>{domain} · Designed in Hải Phòng</div>
				</div>
			</div>
		</footer>
	);
};

export default Footer;
